import React, { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { clearTariffeCache } from '../lib/dataloader'

const GRUPPI = [
  { key: 'GLOBALI',       label: 'Globali (satellitare)' },
  { key: 'EIR',           label: 'EIR (VAN extra usato)' },
  { key: 'LLOYD_VOLANTE', label: "Lloyd's Volante" },
  { key: 'LLOYD_PLUS',    label: "Lloyd's Plus" },
  { key: 'COVEA',         label: 'Covea (diritti fissi)' },
  { key: 'QUIXA',         label: 'Quixa (diritti fissi)' },
  { key: 'SOGESSUR',      label: 'Sogessur (diritti fissi)' },
  { key: 'AUTOCARRI_INTERMEDIARI', label: 'Wakam (autocarri)' },
  // EIR ha anche `eir_parametri` (tabella separata) per i parametri legati alla tariffa principale.
]

export default function AdminParametri() {
  const [globali, setGlobali] = useState([])
  const [parametriComp, setParametriComp] = useState([])
  const [editsGlobali, setEditsGlobali] = useState({})
  const [editsComp, setEditsComp] = useState({})
  const [loading, setLoading] = useState(true)
  const [gruppo, setGruppo] = useState('GLOBALI')

  useEffect(() => { load() }, [])
  async function load() {
    setLoading(true)
    const [g, cp] = await Promise.all([
      supabase.from('parametri_globali').select('*').order('chiave'),
      supabase.from('compagnia_parametri').select('*').order('codice_compagnia').order('chiave'),
    ])
    setGlobali(g.data || [])
    setParametriComp(cp.data || [])
    setLoading(false)
  }

  async function saveGlobale(chiave) {
    const v = editsGlobali[chiave]
    if (v === undefined) return
    const num = parseFloat(v)
    if (!isFinite(num)) return alert('Valore numerico non valido')
    await supabase.from('parametri_globali').update({ valore: num }).eq('chiave', chiave)
    setEditsGlobali(s => { const x = { ...s }; delete x[chiave]; return x })
    clearTariffeCache(); load()
  }

  async function saveComp(codice, chiave) {
    const compKey = `${codice}||${chiave}`
    const v = editsComp[compKey]
    if (v === undefined) return
    const num = parseFloat(v)
    if (!isFinite(num)) return alert('Valore numerico non valido')
    await supabase.from('compagnia_parametri')
      .update({ valore: num })
      .eq('codice_compagnia', codice)
      .eq('chiave', chiave)
    setEditsComp(s => { const x = { ...s }; delete x[compKey]; return x })
    clearTariffeCache(); load()
  }

  if (loading) return <div className="loading">Caricamento...</div>

  return (
    <div>
      <div className="page-header">
        <h1>Parametri</h1>
        <p>Coefficienti globali del satellitare e parametri di calcolo per ciascuna compagnia.</p>
      </div>

      <div className="card" style={{ marginBottom: '1rem' }}>
        <label className="text-small" style={{ display: 'block', marginBottom: 4 }}>Polizza / gruppo</label>
        <select value={gruppo} onChange={e => setGruppo(e.target.value)} style={{ minWidth: 240 }}>
          {GRUPPI.map(g => <option key={g.key} value={g.key}>{g.label}</option>)}
        </select>
      </div>

      {gruppo === 'GLOBALI' && (
        <div className="card">
          <h2 className="card-title">Parametri globali (satellitare)</h2>
          <p className="text-small text-muted" style={{ marginBottom: '1rem' }}>
            Costo del satellitare utilizzato da tutte le compagnie: costo fisso + quota extra in base ai mesi scelti.
          </p>
          <table>
            <thead>
              <tr><th>Chiave</th><th>Valore</th><th>Descrizione</th><th></th></tr>
            </thead>
            <tbody>
              {globali.map(g => {
                const v = editsGlobali[g.chiave] !== undefined ? editsGlobali[g.chiave] : g.valore
                const dirty = editsGlobali[g.chiave] !== undefined
                return (
                  <tr key={g.chiave}>
                    <td><strong>{g.chiave}</strong></td>
                    <td>
                      <input
                        type="number" step="0.01" value={v}
                        onChange={e => setEditsGlobali(s => ({ ...s, [g.chiave]: e.target.value }))}
                        style={{ width: 120, background: dirty ? '#FFF7E5' : 'transparent' }}
                      />
                    </td>
                    <td className="text-small text-muted">{g.descrizione}</td>
                    <td>{dirty && <button className="btn btn-sm btn-primary" onClick={() => saveGlobale(g.chiave)}>Salva</button>}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}

      {gruppo !== 'GLOBALI' && (() => {
        const rows = parametriComp.filter(r => r.codice_compagnia === gruppo)
        if (rows.length === 0) {
          return (
            <div className="card">
              <p className="text-muted">Nessun parametro configurato per questa compagnia.</p>
            </div>
          )
        }
        return (
          <div className="card">
            <h2 className="card-title">Parametri {GRUPPI.find(g => g.key === gruppo)?.label}</h2>
            <table>
              <thead>
                <tr><th>Chiave</th><th>Valore</th><th>Descrizione</th><th></th></tr>
              </thead>
              <tbody>
                {rows.map(r => {
                  const compKey = `${gruppo}||${r.chiave}`
                  const v = editsComp[compKey] !== undefined ? editsComp[compKey] : r.valore
                  const dirty = editsComp[compKey] !== undefined
                  return (
                    <tr key={r.chiave}>
                      <td><strong>{r.chiave}</strong></td>
                      <td>
                        <input
                          type="number" step="0.000001" value={v}
                          onChange={e => setEditsComp(s => ({ ...s, [compKey]: e.target.value }))}
                          style={{ width: 120, background: dirty ? '#FFF7E5' : 'transparent' }}
                        />
                      </td>
                      <td className="text-small text-muted">{r.descrizione}</td>
                      <td>
                        {dirty && (
                          <button className="btn btn-sm btn-primary" onClick={() => saveComp(gruppo, r.chiave)}>
                            Salva
                          </button>
                        )}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )
      })()}
    </div>
  )
}
